import { render, staticRenderFns } from "./search_sj.vue?vue&type=template&id=498a38e0&scoped=true"
import script from "./search_sj.vue?vue&type=script&lang=js"
export * from "./search_sj.vue?vue&type=script&lang=js"
import style0 from "./search_sj.vue?vue&type=style&index=0&id=498a38e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "498a38e0",
  null
  
)

export default component.exports